module.exports = __webpack_public_path__ + "static/media/SBS636.460524bc.png";